import { Session } from '@ory/client';

import { AssignedRegion, OrySession } from './types';
import { defaultSession } from './UserContext';

/**
 * validates if the given ory session expired or not
 */
export const isSessionExpired = (session: OrySession) => {
    if (!session.active || !session.oryID || !session.expiredAt) {
        return true;
    }
    return new Date(session.expiredAt).getTime() < new Date().getTime();
};

/**
 * creates a user session from ory session.
 */
export const createUserSessionFromOrySession = (orySession: Session | undefined) => {
    if (!orySession) {
        return defaultSession;
    }
    const { identity, active, expires_at = '', tokenized } = orySession;
    if (!identity || !tokenized) {
        return defaultSession;
    }

    const userSession: OrySession = {
        oryID: identity.id,
        active: !!active,
        expiredAt: expires_at,
        email: identity.traits['email'],
        jwt: tokenized,
        emailVerified: !!identity.verifiable_addresses?.find(address => address.via == 'email')?.verified
    };
    return userSession;
};

export const getUserRegionId = (name: string, assignedRegions: AssignedRegion[] = []) => {
    return assignedRegions.find(assignedRegion => assignedRegion.name === name)?.id || '';
};
